import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface Step1IntroProps {
  onNext: () => void;
  onBack: () => void;
  angelName?: string;
}
export const Step1Intro: React.FC<Step1IntroProps> = ({
  onNext,
  onBack,
  angelName
}) => {
  return <div className="space-y-6" data-id="element-21890">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-21891">
        {angelName ? `Create Your Fantasy with ${angelName}` : "Let's Create Your Fantasy Scenario"}
      </h2>
      <p className="text-gray-700 dark:text-gray-300" data-id="element-21892">
        {angelName ? `You're about to create a personalized fantasy scenario featuring ${angelName}. This will be a unique experience tailored to your preferences.` : "You're about to create a personalized fantasy scenario. This will be a unique experience tailored to your preferences."}
      </p>
      <div className="p-4 bg-pink-50 dark:bg-pink-900/20 rounded-lg border border-pink-200 dark:border-pink-800/30" data-id="element-21893">
        <h3 className="font-medium text-gray-900 dark:text-white mb-2" data-id="element-21894">
          What to expect:
        </h3>
        <ul className="space-y-2 text-gray-700 dark:text-gray-300" data-id="element-21895">
          <li className="flex items-start gap-2" data-id="element-21896">
            <span className="text-pink-500 text-lg" data-id="element-21897">✓</span>
            <span data-id="element-21898">
              Choose from exciting themes like Hot Tub Night, Office Affair, or
              Lazy Morning
            </span>
          </li>
          <li className="flex items-start gap-2" data-id="element-21899">
            <span className="text-pink-500 text-lg" data-id="element-21900">✓</span>
            <span data-id="element-21901">
              Customize locations, outfits, and the tone of your scenario
            </span>
          </li>
          <li className="flex items-start gap-2" data-id="element-21902">
            <span className="text-pink-500 text-lg" data-id="element-21903">✓</span>
            <span data-id="element-21904">
              Experience immersive, detailed narratives tailored to your
              preferences
            </span>
          </li>
          <li className="flex items-start gap-2" data-id="element-21905">
            <span className="text-pink-500 text-lg" data-id="element-21906">✓</span>
            <span data-id="element-21907">Earn Intimacy XP and unlock new possibilities</span>
          </li>
        </ul>
      </div>
      <div className="bg-yellow-50 dark:bg-yellow-900/20 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800/30" data-id="element-21908">
        <h3 className="font-medium text-gray-900 dark:text-white flex items-center mb-2" data-id="element-21909">
          <span className="mr-2" data-id="element-21910">⚠️</span>
          <span data-id="element-21911">Content Notice</span>
        </h3>
        <p className="text-gray-700 dark:text-gray-300 text-sm" data-id="element-21912">
          Scenarios will contain adult themes and explicit content. By
          proceeding, you confirm you are 18+ and consent to viewing such
          content.
        </p>
      </div>
      <div className="flex justify-between pt-4" data-id="element-21913">
        <button onClick={onBack} className="px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex items-center" data-id="element-21914">
          <ChevronLeft size={16} className="mr-1" data-id="element-21915" />
          <span data-id="element-21916">Back</span>
        </button>
        <button onClick={onNext} className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-lg font-medium hover:from-pink-600 hover:to-purple-600 transition-all shadow-md shadow-pink-500/20 flex items-center" data-id="element-21917">
          <span data-id="element-21918">Continue</span>
          <ChevronRight size={16} className="ml-1" data-id="element-21919" />
        </button>
      </div>
    </div>;
};